import { Component, OnInit } from '@angular/core';

import { CommonModule } from '@angular/common';
import { GenericService } from '../../generic.service';
import { LandingService } from '../../landing-page/service/landing.service';
import { Subscription } from 'rxjs';
import { defaultLanguage } from '../../shared/constants/language.constants';
import { CrowdinService } from '../../shared/service/crowdin.service';

@Component({
    selector: 'app-thank-you',
    imports: [CommonModule],
    templateUrl: './thank-you.component.html',
    styleUrl: './thank-you.component.scss'
})
export class ThankYouComponent implements OnInit {
  deviceData: any = {};
  deviceData$: any = null;
  feedbacks: any = [];
  selectedFeedbackIndex: number | null = null;
  qrId: any;
  accountNumber: string = '';
  machineImageUrl: string = '';
  selectedDevice: any = null;
  selectedMachineName: string | null = null;
  translations: { [key: string]: string } = {};
  currentLanguage: string = defaultLanguage;
  languageOptions: Array<{ value: string }> = [];
  isLoadingTranslations = true;
  subs = new Subscription();

  constructor(
    private genericService: GenericService,
    private landingService: LandingService,
    private crowdinService: CrowdinService,
  ) {
    this.deviceData$ = this.genericService.deviceData.subscribe((data) => {
      if (data) {
        this.deviceData = data;
      }
    });
  }

  ngOnInit() {
    this.languageOptions = this.landingService.getLanguageOptions();

    const stored = localStorage.getItem('deviceData');
    const selectedName = stored
      ? JSON.parse(stored).languageSelected || defaultLanguage
      : defaultLanguage;
    this.currentLanguage = selectedName;

    this.subs.add(
      this.landingService.languageName$.subscribe((langName) => {
        this.currentLanguage = langName;
        this.translations = this.crowdinService.getAllTranslations();
      }),
    );

    this.landingService.loadTranslations(this.currentLanguage);
    this.loadMachineImage();
  }

  async languageChange(event: any) {
    const selectedLang = event.target.value;
    await this.landingService.loadTranslations(selectedLang);
  }

  loadMachineImage() {
    if (!this.deviceData.selectedMachineType) {
      this.machineImageUrl = '';
      return;
    }
    this.landingService
      .getDeviceImageByModelFromModelName(this.deviceData.selectedMachineType)
      .subscribe((imgUrl) => {
        this.machineImageUrl = imgUrl;
      });
  }

  navigateToLadingPage() {
    this.landingService.navigateToHomePage();
  }
}
